/*
browserStorage.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { MFDApp } from "../constants/MFDApp.const";
const prefixKey = (key: string): string => `${MFDApp.storagePrefix}${key}`;

export const setSessionVar = (key: string, value: string): void => {
  if (value) sessionStorage.setItem(prefixKey(key), value);
};

export const getSessionVar = (key: string): string | null => sessionStorage.getItem(prefixKey(key));

export const setLocalVar = (key: string, value: string): void => {
  if (value) localStorage.setItem(prefixKey(key), value);
};

export const getLocalVar = (key: string): string | null => localStorage.getItem(prefixKey(key));

export const clearLocalVar = (key: string): void => {
  localStorage.removeItem(prefixKey(key));
};